import React, {useEffect} from 'react';
import SignInButton from './SignInButton/SignInButton.tsx';
import UserProfileDropdown from './UserProfileDropdown/UserProfileDropdown.tsx';
import NewChatButton from './NewChatButton/NewChatButton.tsx';
import ChatList from "./ChatList/ChatList.tsx";
import IncognitoBanner from "./IncognitoBanner/IncognitoBanner.tsx";
import {useAppStore} from "../../GlobalStore/GlobalStore.ts";
import Menu from "../Top/Menu/Menu.tsx";
import {getAllChats} from "../../Utils/db/chatHistory/loadChat.ts";
import {isMobileApp} from "../../Utils/misc/envNameUtils.ts";

interface MenuPanelProps {}

const MenuPanel: React.FC<MenuPanelProps> = ({ }) => {
    const userObj = useAppStore((state: any) => state.userObj);
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    useEffect(() => {
        if (dynamicStateObj.isMenuOpen) {
            getAllChats(userObj.user, setDynamicStateObj);
        }
    }, [dynamicStateObj.isMenuOpen]);

    const getMenuPanelStyles = () => {
        const styles = [];

        if (dynamicStateObj.isMenuOpen) {
            if (environment.includes("jetbrains") || environment === "chrome") {
                styles.push('-translate-x-0 border-r border-r-neutral-800 border-opacity-70');
            } else {
                styles.push("translate-x-0");
                if (!isMobileApp(environment)) {
                    styles.push("border-r border-r-neutral-800 border-opacity-70");
                }
            }
        } else {
            styles.push(environment.includes("jetbrains") || environment === "chrome" ? 'translate-x-full' : "-translate-x-full");
        }
        styles.push(!isMobileApp(environment) ? "bg-neutral-200 dark:bg-neutral-950" : "bg-neutral-100 dark:bg-neutral-900");
        styles.push(environment.includes("jetbrains") || environment === "chrome" ? "right-0" : "left-0");

        return styles.join(' ');
    };
    const menuPanelStyles = getMenuPanelStyles();

    return (
        /* Mobile needs to be set to the overall app's bg color. The SafeView render does not change its bg color for this.
        Only part of the bg is changed, so trying to trigger a message and stay in sync isn't easy. Leaving as blank is an issue, since the panel defaults to transparent
        */
        <div className={`${menuPanelStyles} h-full w-64 sm:72 md:w-80 lg:w-96 rounded fixed top-0 z-30 transition-transform duration-300 ease-in-out flex flex-col`}>
            {dynamicStateObj.isMenuOpen && (
                <>
                    <div className="h-10 flex mt-0.5 items-center flex-shrink-0">
                        {environment.includes("jetbrains") || environment === "chrome" ? (
                            <>
                                <NewChatButton />
                                <Menu buttonRef={null} />
                            </>
                        ) : (
                            <>
                                <Menu buttonRef={null} />
                                <NewChatButton />
                            </>
                        )}
                    </div>

                    <IncognitoBanner />
                    <ChatList />

                    <div className="flex-shrink-0 mx-auto">
                        {!userObj.user ? (
                            <SignInButton />
                        ) : (
                            <UserProfileDropdown />
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default MenuPanel;
